import {
  Component, DoCheck, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  BaseComponent,
  WmsDialogComponent,
  WmsDialogHeaderComponent,
  WmsDialogBodyComponent,
} from "@wms/components";
import {DialogService} from "@wms/services";
import {LogsService} from "./../../services/logs/logs.service"
import {environment} from "@wms/app";

import {TabsetComponent, TabsModule} from 'ngx-bootstrap/tabs';

const SERVER_LOGS_LINE_COUNT: number = 1000;
const APPLICATION_LOGS_LINE_COUNT: number = 1000;

const APPLICATION_LOGS_TAB_INDEX: number = 0;
const SERVER_LOGS_TAB_INDEX: number = 1;

@Component({
  standalone: true,
  selector: 'wms-logs-dialog',
  templateUrl: './logs-dialog.component.html',
  styleUrls: ['./logs-dialog.component.less'],
  imports: [
    CommonModule,
    TabsModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
  ]
})
export class LogsDialogComponent extends BaseComponent implements DoCheck, OnInit {

  serverLogsElementScrollTop: number;
  applicationLogsElementScrollTop: number;
  rnBuildLogsElementScrollTop: number;
  isNativeMobileApplicationType: boolean;

  @Input() displayLogs: boolean;
  @Output() hideLogs: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("logs_tab_set") logsElement: TabsetComponent;
  @ViewChild("application_logs") applicationLogsElement: ElementRef;
  @ViewChild("server_logs") serverLogsElement: ElementRef;
  @ViewChild("rnBuild_logs") rnBuildLogsElement: ElementRef;

  applicationLogs: string = ``;
  serverLogs: string = ``;

  scrollTimer: number;
  rnBuildLogs: string = ``;

  constructor(private dialogService: DialogService, private logsService: LogsService) {
    super();

  }
  ngOnInit() {
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();
    this.switchToApplicationTab();
  }

  ngDoCheck() {
    this.serverLogsElementScrollTop = this.serverLogsElement?.nativeElement.scrollTop;
    this.applicationLogsElementScrollTop = this.applicationLogsElement?.nativeElement.scrollTop;
    this.rnBuildLogsElementScrollTop  = this.rnBuildLogsElement?.nativeElement.scrollTop;
  }

  scrollToBottom(logsListElement: Element): void {
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      logsListElement.scrollTo({
        top: logsListElement.scrollHeight,
        behavior: "smooth"
      });
    }, 10, false);
  }

  updateServerLogs(callback: Function): void {
    this.logsService.getServerLogs(SERVER_LOGS_LINE_COUNT).then((logs: any) => {
      this.serverLogs = logs.result;
      callback();
    });
  }

  updateApplicationLogs(callback: Function): void {
    this.logsService.getApplicationLogs(APPLICATION_LOGS_LINE_COUNT).then((logs: any) => {
      this.applicationLogs = logs.result;
      callback();
    });
  }

  downloadLogs(): void {
    window.location.href = environment.SERVICES_BASE_PATH + "services/studio/logs/download";
  }

  refreshLogs(): void {
    if (this.serverLogsElement?.nativeElement.style.display === "block") {
      this.updateServerLogs(() => {
        this.scrollToBottom(this.serverLogsElement.nativeElement);
      });
    }
    else if (this.applicationLogsElement?.nativeElement.style.display === "block") {
      this.updateApplicationLogs(() => {
        this.scrollToBottom(this.applicationLogsElement.nativeElement);
      });
    }else {
      this.updateRNBuildLogs()
    }
  }

  switchToApplicationTab(): void {
    if(this.serverLogsElement) {
      this.serverLogsElement.nativeElement.style.display = "none";
      this.applicationLogsElement.nativeElement.style.display = "block";
      this.logsElement.tabs[APPLICATION_LOGS_TAB_INDEX].active = true;
    }

    if (!this.applicationLogs) {
      this.updateApplicationLogs(() => {
        this.scrollToBottom(this.applicationLogsElement.nativeElement);
      });
    }
    else {
      this.applicationLogsElement.nativeElement.scrollTo({
        top: this.applicationLogsElementScrollTop
      });
      this.scrollToBottom(this.applicationLogsElement.nativeElement);
    }
  }

  switchToServerTab(): void {
    this.serverLogsElement.nativeElement.style.display = "block";
    this.applicationLogsElement.nativeElement.style.display = "none";
    this.logsElement.tabs[SERVER_LOGS_TAB_INDEX].active = true;

    if (!this.serverLogs) {
      this.updateServerLogs(() => {
        this.scrollToBottom(this.serverLogsElement.nativeElement);
      });
    }
    else {
      this.serverLogsElement.nativeElement.scrollTo({
        top: this.serverLogsElementScrollTop
      });
      this.scrollToBottom(this.serverLogsElement.nativeElement);
    }
  }
  /*function to be called on switching to RN Build logs tab*/
  switchRNBuildTab() {
    this.serverLogsElement.nativeElement.style.display = "none";
    this.applicationLogsElement.nativeElement.style.display = "none";
    /*update server logs if server logs are empty*/
    if (!this.rnBuildLogs) {
      this.updateRNBuildLogs();
    } else {
      this.rnBuildLogsElement.nativeElement.scrollTo({
        top: this.rnBuildLogsElementScrollTop
      });
      this.scrollToBottom(this.rnBuildLogsElement.nativeElement)
    }
  };

  updateRNBuildLogs() {
    this.logsService.getRNBuildLogs(SERVER_LOGS_LINE_COUNT).then((logs) => {
      this.rnBuildLogs = logs.result;
      this.scrollToBottom(this.rnBuildLogsElement.nativeElement);
    });
  };


  handleLogsViewDialogClose(): void {
    this.hideLogs.emit();
  }
}
